var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M31.9700935,16.2053583 C31.9700935,15.1323478 31.8803738,14.0535372 31.688972,12.9979269 L16.3349533,12.9979269 L16.3349533,19.0763863 L25.1274766,19.0763863 C24.7626168,21.0368054 23.5902804,22.7710224 21.8736449,23.8730331 L21.8736449,27.8170717 L27.1192523,27.8170717 C30.1996262,25.0678448 31.9700935,21.0078052 31.9700935,16.2053583 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M16.3349533,31.6277089 C20.7252336,31.6277089 24.4276636,30.2298952 27.1252336,27.8170717 L21.8796262,23.8730331 C20.4201869,24.8358425 18.5360748,25.3810479 16.3409346,25.3810479 C12.0942056,25.3810479 8.49345794,22.6028207 7.20149533,18.8675843 L1.78841121,18.8675843 L1.78841121,22.933424 C4.5517757,28.263676 10.1801869,31.6277089 16.3349533,31.6277089 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC04",
    d: "M7.19551402,18.8675843 C6.51364486,16.9071651 6.51364486,14.7843444 7.19551402,12.8239252 L7.19551402,8.75808553 L1.78841121,8.75808553 C-0.520373832,13.2183291 -0.520373832,18.4731804 1.78841121,22.933424 L7.19551402,18.8675843 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M16.3349533,6.30466157 C18.6557009,6.26986123 20.8986916,7.1166695 22.5794393,8.67108468 L22.5794393,8.67108468 L27.2269159,4.16444067 C24.2841121,1.4848145 20.3783178,0.0116001133 16.3349533,0.0580005664 C10.1801869,0.0580005664 4.5517757,3.42203342 1.78841121,8.75808553 L7.19551402,12.8239252 C8.48149533,9.0828887 12.0882243,6.30466157 16.3349533,6.30466157 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDefault);
export default __webpack_public_path__ + "static/media/GoogleDefault.aec8b878.svg";
export { ForwardRef as ReactComponent };